import api from "../..";
import type { GetDashboardDataResponse } from "./types";
import type { ApiResponse } from "../../types";

export const getDashboardData = async (): Promise<GetDashboardDataResponse | null> => {

  return await api.get<ApiResponse<GetDashboardDataResponse>>("/admin/home/objects-count/")
  .then(res => res.data.data)
  .catch(() => {return null});
};
